import { create } from 'zustand';

type InstallationsStore = {
  shouldRefetchInstallations: boolean;
  refetchInstallations: () => void;
  resetRefetchInstallations: () => void;
};

export const useInstallationsStore = create<InstallationsStore>((set) => ({
  shouldRefetchInstallations: false,
  refetchInstallations: () => set(() => ({ shouldRefetchInstallations: true })),
  resetRefetchInstallations: () => set(() => ({ shouldRefetchInstallations: false })),
}));
